import { Box, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router';
import { useGetRedirectToken } from '@/shared/api/generated/service-request';
import { LinkUnavailablePage } from './LinkUnavailablePage';

type Kind = 'estimate' | 'invoice' | 'dvi' | 'appointment';

type Props = { kind: Kind; token: string; preserveSearch?: boolean };

export function RedirectToServiceRequest({ kind, token, preserveSearch }: Props) {
  const { data, isLoading, isError } = useGetRedirectToken({ kind, token }, { query: { retry: false } });

  if (isLoading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !data?.publicToken) {
    return <LinkUnavailablePage />;
  }

  const search = preserveSearch && typeof window !== 'undefined' ? window.location.search : '';
  return <Navigate to={`/s/${data.publicToken}${search}`} replace />;
}
